import React from "react";
import "../../components/HnaM3akStyle/intervenantsSection.css";
import { useTranslation } from "react-i18next";

const IntervenantsSection = () => {
  const topRowLogos = [
    {
      src: "https://seeklogo.com/images/M/ministere-de-la-sante-et-de-la-protection-sociale-logo-BD47EE20E7-seeklogo.com.png",
      alt: "Ministère de la Santé",
    },
    {
      src: "https://data.gov.ma/data/uploads/group/2024-08-12-135559.214058logo-MSISF.png",
      alt: "Ministère de La Solidarité",
    },
    {
      src: "https://seeklogo.com/images/E/entraide-national-maroc-logo-7CB8B8E1DA-seeklogo.com.png",
      alt: "Entraide Nationale",
    },
  ];
  const bottomRowLogos = [
    {
      src: "https://seeklogo.com/images/T/touche-pas-a-mon-enfant-logo-74CAFABD91-seeklogo.com.png",
      alt: "Touche pas à mon enfant",
    },
    {
      src: "https://mon-miroir.com/wp-content/uploads/2024/02/MicrosoftTeams-image-2.png",
      alt: "Mon Miroir",
    },
  ];
 const { t } = useTranslation();
  return (
    <div className="intervenants-section pt-5 pb-5">
      <div className="about-area">
        <h2 className="title">{t('intervenants.title')}</h2>

        <div className="container">
          <div className="client-slider">
            <div className="slider">
              <div className="top-row">
                {topRowLogos.map((logo, index) => (
                  <img
                    key={index}
                    src={logo.src}
                    alt={logo.alt}
                    className="logo"
                  />
                ))}
              </div>

              <div className="bottom-row">
                {bottomRowLogos.map((logo, index) => (
                  <img
                    key={index}
                    src={logo.src}
                    alt={logo.alt}
                    className="logo"
                  />
                ))}
              </div>
            </div>
          </div>



        </div>
      </div>
    </div>
  );
};

export default IntervenantsSection;
